import { render, staticRenderFns } from "./loading-block.vue?vue&type=template&id=25673bdc&"
import script from "./loading-block.vue?vue&type=script&lang=ts&"
export * from "./loading-block.vue?vue&type=script&lang=ts&"
import style0 from "./loading-block.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports